import Icon from '../components/Icon'

Icon.register({
  skull: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M256 0c141.4 0 256 100.3 256 224 0 70.1-36.9 132.6-94.5 173.7-9.7 6.9-15.2 18.2-13.5 29.9l9.4 66.2c1.4 9.6-6 18.2-15.7 18.2h-77.7v-56c0-4.4-3.6-8-8-8h-16c-4.4 0-8 3.6-8 8v56h-64v-56c0-4.4-3.6-8-8-8h-16c-4.4 0-8 3.6-8 8v56h-77.7c-9.7 0-17.1-8.6-15.7-18.2l9.4-66.2c1.7-11.8-3.9-23-13.5-29.9-57.6-41.1-94.5-103.6-94.5-173.7 0-123.7 114.6-224 256-224zM160 320c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64zM352 320c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64z'
      }
    ]
  }
})
